module.exports = __webpack_public_path__ + "img/banner7.1af12016.1af12016.jpg";